// extracted by mini-css-extract-plugin
export default {"cart_header":"styles_cart_header__gB2CS","back":"styles_back__5eZ49","title":"styles_title__sPhEZ"};